module.exports = __webpack_public_path__ + "img/IMG_9432_L_Black.1b7bc980.jpg";